import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../userContext";
import { Link } from "react-router-dom";

const Logout = () => {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // Supprime le token d'authentification du localStorage
      localStorage.removeItem("access_token");

      // Optionnel : Effectuer une requête de déconnexion à l'API (si nécessaire)
      // await axios.post('http://127.0.0.1:8000/api/logout', {}, {
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem('access_token')}`
      //   }
      // });

      // Met à jour le contexte utilisateur
      setUser(null);

      // Redirige vers la page de connexion
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  return (
    <header className="header text-white">
      <div className="container">
        <div className="header-cnt">
          <div className="header-cnt-top fs-13 py-2 flex align-center justify-between">
            <>
              <div className="header-cnt-top-l">
                <ul className="flex top-links align-center">
                  <li className="flex align-center">
                    <span className="fs-13">Follow us on</span>
                    <ul className="social-links flex align-center">
                      <li className="mx-2">
                        <a href="https://www.facebook.com" className="fs-15">
                          <i className="fab fa-facebook"></i>
                        </a>
                      </li>
                      <li className="mx-2">
                        <a href="https://www.instagram.com" className="fs-15">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div className="header-cnt-top-r">
                <ul className="top-links flex align-center">
                  <li>
                    <Link to="/seller" className="top-link-itm">
                      <span className="top-link-itm-ico mx-2">
                        <i className="fa-solid fa-circle-question"></i>
                      </span>
                      <span className="top-link-itm-txt">Support</span>
                    </Link>
                  </li>
                  <li className="vert-line"></li>
                  <li>
                    <button onClick={handleLogout} className="top-link-itm">
                      <span className="top-link-itm-ico mx-2">
                        <i className="fa fa-sign-out-alt"></i>
                      </span>
                      <span className="top-link-itm-txt">Logout</span>
                    </button>
                  </li>
                </ul>
              </div>
            </>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Logout;
